export enum SecureWebhookTypes {
    BASIC = "Basic",
    OAUTH = "Oauth",
    CUSTOM_HEADER = "Custom",
    NONE = "None",
}